<template>
    <DCard
        :title="
            __('messages.dashboard.widgets.tasks.title') + ' - ' + __('messages.dashboard.widgets.tasks.description')"
        class="height widget p-3 card"
    >
        <CChartBar
            id="tasks-bar"
            type="bar"
            :data="tasksData"
            :custom-tooltips="false"
            :options="options"
            class="p-3"
            :height="250"
        />

        <span class="help-text">
            {{ '*' + __('messages.dashboard.widgets.tasks.help_text') }}
        </span>
    </DCard>
</template>

<script setup>
import { CChartBar } from '@coreui/vue-chartjs'
import { ref, onMounted } from 'vue'
import { route } from '~@/Composables/route'
import { router } from '@inertiajs/vue3'

const tasksData = ref({})
const labels = ref({})
const taskMap = ref([])

onMounted(async () => {
    window.axios.get(route('widgets.get-data'), {
        params: {
            widget: 'tasks'
        }
    })
        .then(function (response) {
            tasksData.value = buildDataSet(response.data)
            labels.value = response.data.data.labels
            taskMap.value = response.data.params.tasksMap
        })
})

const options = ref({
    onHover: (event, chartElement) => {
        event.native.target.style.height = '250px'
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },

    onClick: (evt, activeEls, chart) => {
        const task = chart.tooltip.title[0]
        let filterQuery = ''

        labels.value.forEach(item => {
            if (item.translation === task) {
                taskMap.value.forEach(map => {
                    if (map.name === item.type) {
                        filterQuery = map.types
                    }
                })
            }
        })

        router.get(route('tasks.tasks.index', {
            _query: {
                types: filterQuery
            }
        }))
    },
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false
            }
        },
        y: {
            type: 'logarithmic',
            grid: {
                display: false
            },
            ticks: {
                format: { maximumSignificantDigits: 1 }
            }
        }
    },
    plugins: {
        legend: {
            display: false
        }
    }
})

function buildDataSet (response) {
    return {
        labels: response.data.labels ? response.data.labels.map(item => item.translation) : [],
        datasets: [
            {
                data: response.data.tasks,
                backgroundColor: ['#08aad2', '#fe6e73', '#d63f38', '#69ae34', '#dfb52c', '#f89256', '#7d8998']
            }
        ]
    }
}
</script>
<style>
.help-text {
    font-size: 12px;
    font-weight: bold;
    padding: 16px 16px 0px 16px;
}
</style>
